// tslint:disable
export enum SearchMode {
    /**
     * @description Search by Account External Id, then by Patient Info. Hierarchy External Ids are excluded.
     */
    Default = 1,
    /**
     * @description Search by Patient Info, then by Hierarchy External Ids. 
     */
    PatientInfoThenHierarchyExternalIds = 2,
    /**
     * @description Search by Hierarchy External Ids, then by Patient Info
     */
    HierarchyExternalIdsThenPatientInfo = 3,
}
(SearchMode as any)['DEFAULT'] = 1;
(SearchMode as any)['PATIENTINFOTHENHIERARCHYEXTERNALIDS'] = 2;
(SearchMode as any)['HIERARCHYEXTERNALIDSTHENPATIENTINFO'] = 3;
